(function (upp) {
    'use strict';
    upp
        .config(['$routeProvider',
        function ($routeProvider) {

            var resolver = {
                resolve:$routeProvider.ResolverFactory.moduleIsActivated("outlets").resolver
            };
            $routeProvider
            .when('/outlets', {
                templateUrl: require('../templates/outlets-catalog.html'),
                resolve: resolver,
            })
            .when('/promotions',{redirectTo: '/outlets'})
        }])
    ;
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/outlets/routes/outlets-routes.js